import { useState, useEffect, useCallback } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Select,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import {
  WH_EXCEPTIONS,
  WEEKEND_HOLIDAY_LIST
} from "../../../../apiServices/API_ENDPOINTS";
import { postData, getData, putData } from "../../../../apiServices/common";
import { alertPop } from "../../../../apiServices/common/helper";
import HandleNotification from "../../../../common/Notification";
import CustomDatePicker from "common/CustomDatePicker";

const { Option } = Select;

const ExceptionForm = (props) => {
  // Props
  const { form, editMode, viewMode } = props;
  const [weekendHolidayExceptionList, setWeekendHolidayExceptionList] = useState([]);
  const [selectedHoliday, setSelectedHoliday] = useState(null);
  const [currentExceptionData, setCurrentExceptionData] = useState(null);

  // Router
  const navigate = useNavigate();
  const { id } = useParams();

  const getWeekendHolidayExceptionList = useCallback(async () => {
    let response = await getData(WEEKEND_HOLIDAY_LIST);
    if (response && response?.status === 200) {
      setWeekendHolidayExceptionList(response?.data?.data || []);
    } else {
      alertPop(
        "error",
        response?.messages ? response?.messages : "Something Went Wrong!",
      );
    }
  }, []);

  const onSelectWeekendHoliday = (value) => {
    const foundItem = weekendHolidayExceptionList.find((item) => item.serial === value);
    setSelectedHoliday(foundItem);
  };

  const getSelectedExceptionInfo = useCallback(
    async (id) => {
      const query = `${WH_EXCEPTIONS}/${id}/show`;
      const response = await getData(query);

      if (response && response?.data?.code === 200) {  
        const exceptionData = response?.data?.data;
        setCurrentExceptionData(exceptionData);
        
        // Find the corresponding holiday from the list
        const matchingHoliday = weekendHolidayExceptionList.find(
          (holiday) => holiday.id === exceptionData.weekend_holiday_id
        );

        form.setFieldsValue({
          weekend_holiday_id: matchingHoliday ? matchingHoliday.serial : null,
          reason: exceptionData.reason,
        });
        
        if (matchingHoliday) {
          setSelectedHoliday(matchingHoliday);
        }
      } else {
        HandleNotification(
          "error",
          "bottomRight",
          "Error in fetching weekend Info",
          null,
        );
      }
    },
    [form, weekendHolidayExceptionList],
  );

  // Effects
  useEffect(() => {
    getWeekendHolidayExceptionList();
  }, [getWeekendHolidayExceptionList]);

  useEffect(() => {
    if (id && weekendHolidayExceptionList.length > 0) {
      getSelectedExceptionInfo(id);
    }
  }, [editMode, id, getSelectedExceptionInfo, weekendHolidayExceptionList]);

  const onFinishException = async (values) => {
    const selectedHolidayFromForm = weekendHolidayExceptionList.find(
      (item) => item.serial === values.weekend_holiday_id
    );

    const query = editMode
      ? `${WH_EXCEPTIONS}/${id}`
      : `${WH_EXCEPTIONS}`;

    const bodyData = {
      serial: values.weekend_holiday_id,
      weekend_holiday_id: selectedHolidayFromForm?.id,
      type_name: selectedHolidayFromForm?.type || (editMode ? currentExceptionData?.type_name : null),
      reason: values?.reason,
    };
    
    console.log("bodyData", bodyData);
    
    const response = editMode 
      ? await putData(query, bodyData) 
      : await postData(query, bodyData);

    if (response && response?.code === 200) {
      HandleNotification(
        "success",
        "bottomRight",
        `Weekend Holiday Exception ${editMode ? "updated" : "added"} successfully!`,
        null,
      );
      form.resetFields();
      navigate("/production-planning/exceptions");
    } else {
      HandleNotification(
        "error",
        "bottomRight",
        `Error ${editMode ? "updating" : "adding"} exception!`,
        null,
      );
    }
  };

  return (
    <div className="containt-body pt-3">
      <Form
        layout="vertical"
        form={form}
        name="control-hooks"
        onFinish={onFinishException}
      >        
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item 
              label="Weekend/Holiday" 
              name="weekend_holiday_id"
              rules={[{ required: true, message: 'Please select a weekend/holiday' }]}
            >
              <Select              
                style={{ width: "100%" }}
                placeholder="Date : Title"
                optionFilterProp="children"
                onChange={onSelectWeekendHoliday}
              >
                {weekendHolidayExceptionList.map((option) => (
                  <Option
                    key={option.serial}
                    value={option.serial}
                  >
                    {option?.date}: {option?.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={12}>
            <Form.Item
              label="Reason"
              name="reason"
              rules={[{ required: true, message: 'Please input a reason' }]}
            >
              <Input placeholder="Reason" />
            </Form.Item>
          </Col>
          
          <Col className="gutter-row" span={12}>
            <Form.Item
              label="Entry date"
              name="entry_date"
              initialValue={moment().format("YYYY-MM-DD")}
            >
              <CustomDatePicker disabled value={moment().format("YYYY-MM-DD")}/>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={12}>
            <Form.Item
              label="Entry User"
              name="entry_user"
              initialValue={localStorage.getItem("name") || "User"}
            >
              <Input placeholder="Entry Date" disabled size="small" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ExceptionForm;